import './LogoLoader.scss';

type LogoLoaderVariant = 'clock' | 'swirl' | 'orbit';

type Sparkle = { cx: number; cy: number; color: string; duration: string; direction: 'normal' | 'reverse'; };

const SPARKLES: Sparkle[] = [
	{ cx: 106, cy: 50, color: '#55B267', duration: '7s', direction: 'normal' },
	{ cx: 78, cy: 98.5, color: '#46C0ED', duration: '9s', direction: 'reverse' },
	{ cx: 22, cy: 98.5, color: '#E62E7A', duration: '8s', direction: 'normal' },
	{ cx: -6, cy: 50, color: '#FCC008', duration: '6s', direction: 'reverse' },
	{ cx: 22, cy: 1.5, color: '#55B267', duration: '10s', direction: 'normal' },
	{ cx: 78, cy: 1.5, color: '#46C0ED', duration: '7.5s', direction: 'reverse' },
];

const LogoLoader = ({ size = 88, variant = 'clock' }: { size?: number; variant?: LogoLoaderVariant; }) => (
	<svg className={`logo-loader logo-loader--${variant}`} width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
		{variant === 'swirl' && (
			<g className="logo-loader__sparkles">
				{SPARKLES.map((sparkle, index) => (
					<circle
						key={index}
						className="logo-loader__sparkle"
						cx={sparkle.cx}
						cy={sparkle.cy}
						r={3.5}
						fill={sparkle.color}
						style={{ animationDuration: sparkle.duration, animationDirection: sparkle.direction }}
					/>
				))}
			</g>
		)}

		<path className="logo-loader__piece logo-loader__piece--1" fill="#55B267" d="M91.1,0H48.2L100,53.5V11C100,4.9,96,0,91.1,0z" />
		<path className="logo-loader__piece logo-loader__piece--2" fill="#46C0ED" d="M0.1,65V11c0-6.1,4-11,8.9-11h32.7l37.7,39l-21,26H0.1z" />
		<path className="logo-loader__piece logo-loader__piece--3" fill="#E62E7A" d="M0,70.2V89c0,6.1,4,11,8.9,11h21.1L54,70.2H0z" />
		<path className="logo-loader__piece logo-loader__piece--4" fill="#FCC008" d="M35.9,100h55.2c4.9,0,8.9-4.9,8.9-11V60.4l-17.4-18L35.9,100z" />
	</svg>
);

export default LogoLoader;
